import { render, staticRenderFns } from "./WFieldCgu.vue?vue&type=template&id=66c47433&"
import script from "./WFieldCgu.vue?vue&type=script&lang=ts&"
export * from "./WFieldCgu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports